// extracted by mini-css-extract-plugin
export const heroLayout = "hero-module--heroLayout--I3ioX";
export const heroTextLayout = "hero-module--heroTextLayout--3r8Bc";
export const heroTitle = "hero-module--heroTitle--1N9ny";
export const heroBlurb = "hero-module--heroBlurb--3FPKR";
export const heroText = "hero-module--heroText--vPTm4";
export const heroImage = "hero-module--heroImage--2RKUU";